import { IApplicationState } from '../../../../../../../../types/types';
import { connect } from 'react-redux';
import { ArchiveOnDeletePanelSection } from '../../components/ArchiveOnDeletePanelSection/ArchiveOnDeletePanelSection';
import { IArchiveOnDeleteSectionFields } from '../../components/ArchiveOnDeletePanelSection/types';
import { getIsUserEssentialPlanOnly } from '../../../../../../../../store/model/authUser/selectors/getIsUserEssentialPlanOnly';
import {
    getShowProFeaturesTrial
} from '../../../../../../../../store/model/authUser/selectors/getShowProFeaturesTrial';

const mapStateToProps = (
    state: IApplicationState,
): IArchiveOnDeleteSectionFields => {
    return {
        isEssentialFeature: getIsUserEssentialPlanOnly(state),
        isProFeature: getShowProFeaturesTrial(state),
    }
};

export const ArchiveOnDeletePanelSectionHOC = connect(
    mapStateToProps,
    null
)(ArchiveOnDeletePanelSection);

ArchiveOnDeletePanelSectionHOC.displayName = 'ArchiveOnDeletePanelSectionHOC';
